import { combineEpics } from 'redux-observable';
import userEpics from './user/epics';
import alertEpics from './alert/epics';
import loadingEpics from './loading/epics';

const rootEpic = combineEpics(
  ...userEpics,
  ...alertEpics,
  ...loadingEpics
);

export default rootEpic;
